<template>
	<v-menu
		v-if 					= "info_compt.type == 'date_range'"
        :ref 					= "'menu' + ref"
        v-model 				= "menu"
        :close-on-content-click = "false"
        transition 				= "scale-transition"
        offset-y
        min-width 				= "auto"
      >
        <!-- open-on-hover -->
        <!-- :return-value.sync 		= "dates" -->
        <template v-slot:activator="{ on, attrs }">
	        <v-text-field
	            v-model 			= "dates"
	          	:label              = "$ml.get(info_compt.text)"
	            :placeholder        = "$ml.get(info_compt.placeholder)"

	            prepend-inner-icon 	= "mdi-calendar"
	            readonly
	            v-bind 				= "attrs"
	            v-on 				= "on"
	            outlined
	            dense
	            hide-details
	            chips
	            small-chips
	            multiple		
	            

	        >									        	
	        </v-text-field>
	        <!-- combobox -->

        </template>
        <v-date-picker
          	v-model 	= "dates"
          	no-title
          	scrollable
          	range
          	@change 		= "actions('save_dates', dates)" 
        	@input 			= "info_compt.use_input ? actions('save_dates', dates) : ''" 
        >
	        <v-btn
	            x-small
	            v-show  = "false"
	            color   = "primary"
	            @click  = "actions('save_dates', dates)"
	        >
	            {{ $ml.get('confirm') }}
	        </v-btn>
          	<v-spacer></v-spacer>
	        <v-btn
	        	x-small
	            v-show  = "false"	        	
	            color  = "error"
	            @click = "actions('cancel_dates')"
	        >
	            {{ $ml.get('close') }}
	        </v-btn>
        </v-date-picker>
    </v-menu>

    	<!-- time pickers -->

        <!-- :nudge-right 			= "40" -->
        <!-- open-on-hover		         -->
    <v-menu
        offset-y						
        :return-value.sync 		= "picker"
    	v-else-if 				= "info_compt.type == 'time_picker'"
        :ref 					= "info_compt.ref"
        v-model 				= "menu_picker"
        :close-on-content-click = "false"
        transition 				= "scale-transition"
        max-width 				= "290px"
        min-width 				= "290px"
    >
        <template v-slot:activator="{ on, attrs }">
          	<!-- DIGITAL 24h en UN SOLO campo: se digitan 4 números (HHMM -> HH:MM).
          	     Primer par = hora, segundo par = minutos. El icono del reloj abre el análogo. -->
          	<v-text-field
	            outlined
	            dense
	            hide-details
	            :value 	 			= "picker"
	            @input 	 			= "onTimeInput"
	            @blur 	 			= "onTimeBlur"
	            @keyup.enter 		= "onTimeBlur"
	            :label 		 		= "info_compt.text"
	            placeholder 		= "HH:MM"
	            maxlength 			= "5"
	            inputmode 			= "numeric"
	            prepend-inner-icon 	= "mdi-clock-time-four-outline"
	            @click:prepend-inner = "menu_picker = true"
	            v-bind 		 		= "attrs"
          	></v-text-field>
        </template>
	        <!-- full-width -->
        <v-time-picker
	        no-title
	        scrollable
	        v-if 			= "menu_picker"
	        v-model 		= "picker"
	        format 			= "24hr"
	        @click:minute 	= "save_time(info_compt.key, picker, info_compt.ref)"
	        @input 		 	= "render_date(picker)" 
        ></v-time-picker>
    </v-menu>
</template>
<script>
	import format from "@/class/formats"
	export default {
		name  : 'dates',
		props : [
			'info_to_component',
			'info_to_dates',
			'ref_to_component'
		],
		data  : () => ({
			info 	  	: {},
			list 	  	: [],
			search 	  	: '',
			info_compt 	: {},
			list_search : [],
			onInputChange   : '',
			input 			: '',
			menu 		 	: false,
			dates 		 	: [], 	
			menu_picker 	: false, // menu
			picker 			: "00:00",
			show 			: {
				confirm : false
			},
			ref 		: "",
			controls_send : {
				dates : false,
			}
		}), // data
		/*
			key 		: 'search',
			text 		: 'search',
			placeholder : 'device',
			list 		: 'list_devices',
			key_list	: 'deviceId',
			text_list 	: 'name',
			type 		: 'select_searcher',
			key_search  : 'name',
			key_search_1 : 'deviceId',
			cols 		: {
				col : 2,
			},

			============
			dates 		 	: [], 
			picker 			: {
				start	: "00:00", // 
				end		: "23:59",
			},
		*/
		watch : {
			/*dates: function(val){
				if (val && val.length >= 1) {
					this.render_date(val);
				}
			}, // dates*/
							info_to_dates: function(newVal) {
					if (newVal) {
						this.render_info(this.info_compt);
					}
				},
			menu : function(val) {
				if (!val) {
					// console.log("MENU DATEs ")
					if (this.dates && this.dates.length > 0 && !this.controls_send.dates) {
						// console.log("exec date menu")
						this.render_date(this.dates);
					}
				}
			},
		}, // watch

		created(){
			// let f 	= new Date();
			// console.log(f, "NEW DATE ******************")
	      	// let today = f.getFullYear() +  "/" + f.getMonth() + "/" + f.getDate();
			// let dt  	= this.formatDate(new Date());
			// this.dates.push(today, today);
			
			// setting format
		  
	      	this.$Format.update_list('ml', this.$ml);      
			if (this.info_to_component) {
				this.render_info(this.info_to_component);
			}

			if (this.ref_to_component) {
				this.ref = this.ref_to_component;
			}
		}, // created

		methods : {

			actions(act, item, opt){
				// console.log("DATE Actions : ", act, item, opt);
				switch (act){
					case ('set_dates') : {
						// this.dates = item;
						this.menu = false;

					}break;
					case ('search') : {
						// this.get_list(true)
					}break;
					case('save_dates') : {
						this.actions("time_control_dates");
						this.render_date(item);
					}
					break;
					case('cancel_dates') : {
						this.actions('time_control_dates');
						this.menu = false
					}
					break;
					case('time_control_dates') : {
						this.controls_send.dates = true;
						const timer = setTimeout(()=>{							
							this.controls_send.dates = false;
							clearTimeout(timer);
						},500)

					}break;
					default : {
						console.log("this option not exist ")
					}
				};
			}, // actions

			render_info(item){
				if (item) {
					this.info_compt = item;
					
					if (item.type == 'date_range') {
						if (this.info_to_dates && this.info_to_dates.length > 0){
							this.dates = this.info_to_dates;
						}
					}else
					if (item.type == 'time_picker') {
						if (this.info_to_dates){
							this.picker = this.info_to_dates;
						}
					}
				}else{
					console.warn("No found item for render searcher : ", item);
				}
			}, // render info

			render_date(item){
				if (item) {

					if (this.info_compt && (this.info_compt.type == 'date_range' || this.info_compt.type == 'time_picker')) {
						if (this.info_compt.type == 'date_range') {
							item.sort(function(a,b){
							  // Turn your strings into dates, and then subtract them
							  // to get a value that is either negative, positive, or zero.
							  return  new Date(a) - new Date(b);
							});
							 
						
						}
						this.$emit("receive_info", item);
						this.actions('set_dates')				
					}else{
						console.warn("Not found select type for return ", this.info_compt)
					}
				}else{
					console.warn("Not receive info item to send date / time : ", item);
				}				
			}, // render search

			formatDate (date) {
		        if (!date) return null

		        const [year, month, day] = date.split('/')
		        return `${year}-${month}-${day}`
		    
		    }, // formatDate

			save_time(key, item, ref){
 				this.$refs[ref].save(this.picker); // [0]
 				this.picker = item;
 				// this.$refs[item].save(picker[item_search.key])
			},
			// --- Input digital de hora en UN solo campo (24h) ---
			// Mientras escribe: deja solo dígitos (máx 4) y formatea HHMM -> HH:MM
			onTimeInput(val){
				let d = String(val == null ? '' : val).replace(/\D/g, '').slice(0, 4);
				this.picker = d.length >= 3 ? d.slice(0, 2) + ':' + d.slice(2) : d;
			},
			// Al salir / Enter: normaliza a HH:MM válido (hora 0-23, min 0-59) y propaga
			onTimeBlur(){
				let d = String(this.picker == null ? '' : this.picker).replace(/\D/g, '');
				if (!d) return;
				d = d.slice(0, 4);
				let h = Math.min(23, Math.max(0, parseInt(d.slice(0, 2) || '0', 10) || 0));
				let m = Math.min(59, Math.max(0, parseInt(d.slice(2, 4) || '0', 10) || 0));
				this.picker = String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0');
				this.render_date(this.picker);
			},
		}, // methods

		computed : {
			

		}, // computed
	}
</script>